import React, { useState } from 'react';
import { SnippetManagement } from '../SnippetManagement';
import { VoiceNoteManagement } from '../VoiceNoteManagement';
import { Typography } from 'interfaces/typography';

enum LinkedInTabs {
  SNIPPETS = 'Snippets',
  VOICE_NOTES = 'Voice Notes'
}

export function LinkedInManagement() {
  const [activeTab, setActiveTab] = useState<LinkedInTabs>(LinkedInTabs.SNIPPETS);

  const renderTabButton = (tab: LinkedInTabs) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`px-4 py-2 border-b-2 transition-colors duration-200 ${
        activeTab === tab
          ? 'border-blue-600'
          : 'border-transparent hover:border-gray-300'
      }`}
    >
      <Typography
        variant="mediumParagraph"
        color={activeTab === tab ? '#2563eb' : '#6b7280'}
        fontWeight={500}
      >
        {tab}
      </Typography>
    </button>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case LinkedInTabs.SNIPPETS:
        return <SnippetManagement />;
      case LinkedInTabs.VOICE_NOTES:
        return <VoiceNoteManagement />;
      default:
        return <SnippetManagement />;
    }
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header with title and tabs */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="mb-4">
          <Typography variant="h2" color="#1F2937" fontWeight={600}>
            LinkedIn
          </Typography>
          <Typography variant="smallParagraph" color="#6B7280" style={{ marginTop: '0.25rem' }}>
            Manage your LinkedIn snippets and voice notes for prospecting
          </Typography>
        </div>

        {/* Tab Navigation */}
        <div className="flex space-x-6 border-b border-gray-200">
          {Object.values(LinkedInTabs).map(tab => renderTabButton(tab))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        <div className="h-full">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
}